module.exports = __webpack_public_path__ + "media/images/start_header-faa5dd771e4475323f0039de601200f2.webp";